<!-- 
CategoryPreviewModal.vue
功能：編輯名單-預覽視窗
作者：i9400538 陳博承
完成：2021-06-18
-->
<template>
  <div id="category-preview-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-12 pl-0">
            <h3 class="modal-title">畫面預覽</h3>
          </div>
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
        </div>

        <div class="container-fluid over-flow-hidden">
          <div class="mb-3 mb-3-block">
            <div class="float-left w-75">
              <h4 class="mb-line text-green mt-0 mb-0">
                {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
                <a
                  v-if="categoryInfo.upload_file"
                  class="text-orange text-decoration-none"
                >
                  <i class="icon-attach ml-2 cursor-pointer"></i>點我
                </a>
              </h4>
              <div class="mb-line">
                <span
                  class="font-weight-bold mr-2"
                >{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span>
              </div>
              <div class="font-weight-bold mb-line w-75" v-html="replaceTextWithRedStyle(categoryInfo,'description')"></div>
              <div class="font-weight-bold mb-line w-75" v-html="replaceTextWithRedStyle(categoryInfo,'description2')"></div>
              <div class="font-weight-bold mb-line w-75" v-html="replaceTextWithRedStyle(categoryInfo,'description3')"></div>
            </div>
            <div class="float-left w-25">
              <div class="mb-line">
                <span class="font-weight-bold mr-2">維護單位</span>
                <span>{{ categoryInfo.dev_name }}</span>
              </div>
              <div class>
                <span class="font-weight-bold mr-2">聯絡電話</span>
                <span>{{ categoryInfo.contact }}</span>
              </div>
              <div class="mb-line">
                <span class="font-weight-bold mr-2">聯絡分機</span>
                <span>{{ categoryInfo.contact_tel }}</span>
              </div>
              <div>
                <a class="btn btn-default m-0">滿意度調查</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "CategoryPreviewModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    categoryInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods:{
    //字串中指定的包裹文字以紅字取代
    replaceTextWithRedStyle(array,arrayItemName){
      if(array[arrayItemName] == undefined){
        return 
      } 
      return array[arrayItemName].replace(/\$reds(.*?)\$rede/g, '<span class="text-red">$1</span>')
    }
  }
};
</script>
<style scoped>
.over-flow-hidden {
  overflow: hidden;
}
.mb-3-block {
  overflow: hidden;
  max-height: 220px;
}
.text-decoration-none {
  text-decoration: none;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
